import { ListingId, ListingSearchResult, TabViewEnum, TravelWalletOffer } from "redmond";
import * as actionTypes from "./constants";
import * as H from "history";
import { VacationRentalShopCallError } from "../reducer";
import {
  Price,
  VacationRentalCalendarResponse,
} from "redmond/apis/tysons/vacation-rentals";

export interface IFetchVacationRentalShop {
  type: actionTypes.FETCH_VACATION_RENTAL_SHOP;
  history: H.History;
  options?: {
    overrideStateByQueryParams?: boolean;
    forceCallVRAvailability?: boolean;
    fetchListingCalendar?: boolean;
  };
  includePremierCollection?: boolean;
}

export const fetchVacationRentalShop = (
  history: H.History,
  options?: {
    overrideStateByQueryParams?: boolean;
    forceCallVRAvailability?: boolean;
    fetchListingCalendar?: boolean;
  },
  includePremierCollection?: boolean
): IFetchVacationRentalShop => ({
  type: actionTypes.FETCH_VACATION_RENTAL_SHOP,
  history,
  options,
  includePremierCollection,
});

export interface ISetVacationRentalShopCallStateFailed {
  type: actionTypes.SET_VACATION_RENTAL_SHOP_CALL_STATE_FAILED;
  vrShopCallError: VacationRentalShopCallError;
}

export const setVacationRentalShopCallStateFailed = (
  vrShopCallError: VacationRentalShopCallError
): ISetVacationRentalShopCallStateFailed => ({
  type: actionTypes.SET_VACATION_RENTAL_SHOP_CALL_STATE_FAILED,
  vrShopCallError,
});

export interface ISelectHome {
  type: actionTypes.SELECT_HOME;
  home: ListingSearchResult;
}

export const selectHome = (home: ListingSearchResult): ISelectHome => ({
  type: actionTypes.SELECT_HOME,
  home,
});

export interface ISetSelectedListingId {
  type: actionTypes.SET_SELECTED_LISTING_ID;
  id: ListingId;
}

export const setSelectedListingId = (id: ListingId): ISetSelectedListingId => ({
  type: actionTypes.SET_SELECTED_LISTING_ID,
  id,
});

export interface ISetListingCalendar {
  type: actionTypes.SET_LISTING_CALENDAR;
  calendar?: VacationRentalCalendarResponse;
}

export const setListingCalendar = (
  calendar?: VacationRentalCalendarResponse
): ISetListingCalendar => ({
  type: actionTypes.SET_LISTING_CALENDAR,
  calendar,
});

export interface ISetNotifyIfShopAndBookPriceDifferFlag {
  type: actionTypes.SET_NOTIFY_IF_SHOP_AND_BOOK_PRICE_DIFFER_FLAG;
  notify: boolean;
}

export const setNotifyIfShopAndBookPriceDifferFlag = (
  notify: boolean
): ISetNotifyIfShopAndBookPriceDifferFlag => ({
  type: actionTypes.SET_NOTIFY_IF_SHOP_AND_BOOK_PRICE_DIFFER_FLAG,
  notify,
});

export interface ISetTabView {
  type: actionTypes.SET_TAB_VIEW;
  tabView: TabViewEnum;
}

export const setTabView = (tabView: TabViewEnum): ISetTabView => ({
  type: actionTypes.SET_TAB_VIEW,
  tabView,
});

export interface ISetIsBoosted {
  type: actionTypes.SET_IS_BOOSTED;
  isBoosted: boolean;
}

export const setIsBoosted = (isBoosted: boolean): ISetIsBoosted => ({
  type: actionTypes.SET_IS_BOOSTED,
  isBoosted,
});

export interface ISetShopOffer {
  type: actionTypes.SET_SHOP_OFFER;
  offer?: TravelWalletOffer;
}

export const setShopOffer = (offer?: TravelWalletOffer): ISetShopOffer => ({
  type: actionTypes.SET_SHOP_OFFER,
  offer,
});

export interface ISetListPrice {
  type: actionTypes.SET_LIST_PRICE;
  listPrice: Price | null | undefined;
}

export const setListPrice = (
  listPrice: Price | null | undefined
): ISetListPrice => ({
  type: actionTypes.SET_LIST_PRICE,
  listPrice,
});

export interface ICheckLifestyleEligibility {
  type: actionTypes.CHECK_LIFESTYLE_ELIGIBILITY;
}

export const checkLifestyleEligibility = (): ICheckLifestyleEligibility => ({
  type: actionTypes.CHECK_LIFESTYLE_ELIGIBILITY,
});

export interface ISetLifestyleEligibility {
  type: actionTypes.SET_LIFESTYLE_ELIGIBILITY;
  isEligible: boolean;
}

export const setLifestyleEligibility = (
  isEligible: boolean
): ISetLifestyleEligibility => ({
  type: actionTypes.SET_LIFESTYLE_ELIGIBILITY,
  isEligible,
});

export type VacationRentalShopActions =
  | IFetchVacationRentalShop
  | ISetVacationRentalShopCallStateFailed
  | ISelectHome
  | ISetListingCalendar
  | ISetSelectedListingId
  | ISetNotifyIfShopAndBookPriceDifferFlag
  | ISetTabView
  | ISetShopOffer
  | ISetIsBoosted
  | ISetListPrice
  | ICheckLifestyleEligibility
  | ISetLifestyleEligibility;
